import React, { CSSProperties, FC, useState } from 'react'
import type { WidgetButtonProps } from './widget-button.d'
import styles from './widget-button.module.scss'

export const WidgetButton: FC<WidgetButtonProps> = ({
  children,
  type,
  form,
  isTextUpper,
  disabled,
  defaultTextColor,
  hoverTextColor,
  hoverBorderColor,
  defaultBorderColor,
  defaultBackgroundColor,
  hoverBackgroundColor,
  onClick,
}) => {
  const [isHover, setIsHover] = useState(false)
  const customClass: CSSProperties = {
    textTransform: isTextUpper ? 'uppercase' : 'none',
    background: isHover ? hoverBackgroundColor : defaultBackgroundColor,
    color: isHover ? hoverTextColor : defaultTextColor,
    border: isHover
      ? `1px solid ${hoverBorderColor}`
      : `1px solid ${defaultBorderColor}`,
  }

  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }

  return (
    <button
      className={styles['root']}
      style={customClass}
      type={type}
      disabled={disabled}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      form={form}
    >
      {children}
    </button>
  )
}
